export default __webpack_public_path__ + "static/natasha2-c550f140afea6b0bcc608f2433b3ecad.jpg";